import { CurrentAddress } from 'src/client/appTypings';
import { createAction } from '@reduxjs/toolkit';

export const geoLocationFetchSuccessAction = createAction<CurrentAddress>(
  'geoLocation/fetchSuccess'
);
